<template>
  <div class="parent">
    <l-map
      class="map"
      :zoom="zoom"
      :center="center"
      :options="{ zoomControl: false }"
    >
      <l-tile-layer :url="url" />
      <l-control position="topleft">
        <a href="/monitoring" class="monitor" target="_blank">
          <div class="monitor-btn">
            <vs-icon icon="phonelink_ring" class="mr-2"></vs-icon>
            <span>Monitoring Mode</span>
          </div>
        </a>
      </l-control>

      <l-marker :lat-lng="center" @click="showInfo"> </l-marker>

      <l-control position="topleft">
        <div v-show="showPopup">
          <div class="vehicle-info">
            <div class="action">
              <a>Report</a>
              <a>Share</a>
            </div>
          </div>
        </div>
      </l-control>
      <l-control position="bottomleft">
        <!-- <vs-button
          @click="active = !active"
          class="sidebar-btn"
          color="primary"
          type="filled"
          >Open Sidebar</vs-button
        > -->
      </l-control>
      <l-control>
        <div id="sidebar">
          <div id="toggle-btn" class="p-2 mr-2" @click="showVehicleList">
            <img
              src="@/assets/images/tabler-icon/edited/indent-decrease-white.png"
            />
          </div>
          <div class="sidebar-scroll">
            <div class="inner-sidebar">
              <b-row>
                <b-col cols="12">
                  <div class="px-5 my-5">
                    <h4>List Kendaraan</h4>
                  </div>
                </b-col>
                <b-col cols="12">
                  <div class="px-5">
                    <ul class="centerx d-flex justify-content-between mt-4">
                      <li>
                        <vs-radio
                          v-model="type"
                          vs-value="vehicle"
                          class="mb-5 mr-3"
                          >By Vehicle</vs-radio
                        >
                      </li>
                      <li>
                        <vs-radio v-model="type" vs-value="user"
                          >By User</vs-radio
                        >
                      </li>
                    </ul>
                  </div>
                </b-col>
                <b-col cols="12">
                  <div class="search-input p-5">
                    <feather-icon icon="SearchIcon" class="mr-5" />
                    <input type="text" placeholder="Search" />
                  </div>
                </b-col>
                <b-col cols="12">
                  <div class="user-tree-data p-5">
                    <div
                      class="user-parent p-3 d-flex justify-content-between"
                      :class="treedata1 ? null : 'collapsed'"
                      :aria-expanded="treedata1 ? 'true' : 'false'"
                      aria-controls="treeData-1"
                      @click="treedata1 = !treedata1"
                    >
                      <div class="user-head d-flex align-items-center">
                        <div class="icon-title mr-3 d-flex align-items-center">
                          <svg
                            style="width: 1.4rem"
                            height="auto"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.5 15L12.5 9L18.5 15"
                              stroke="#fff"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6.5 15L12.5 9L18.5 15"
                              stroke="white"
                              stroke-opacity="0.1"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <span class="user-title">Demo</span>
                      </div>
                      <div class="user-icon d-flex align-items-center">
                        <svg
                          style="width: 1.4rem; height: 1.4rem"
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12.5"
                            cy="12"
                            r="9"
                            stroke="#fff"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <circle
                            cx="12.5"
                            cy="12"
                            r="9"
                            stroke="#fff"
                            stroke-opacity="0.1"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <circle
                            cx="12.5"
                            cy="10"
                            r="3"
                            stroke="#fff"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <circle
                            cx="12.5"
                            cy="10"
                            r="3"
                            stroke="#fff"
                            stroke-opacity="0.1"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M6.66797 18.849C7.17621 17.1575 8.73372 15.9995 10.5 16H14.5C16.2686 15.9994 17.8277 17.1604 18.334 18.855"
                            stroke="#fff"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M6.66797 18.849C7.17621 17.1575 8.73372 15.9995 10.5 16H14.5C16.2686 15.9994 17.8277 17.1604 18.334 18.855"
                            stroke="#fff"
                            stroke-opacity="0.1"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>

                    <b-collapse visible id="treeData-1" v-model="treedata1">
                      <!-- USER CHILDREN -->
                      <div
                        class="sub-user-parent p-3 ml-5 d-flex justify-content-between"
                        :class="treedata2 ? null : 'collapsed'"
                        :aria-expanded="treedata2 ? 'true' : 'false'"
                        aria-controls="treeData-2"
                        @click="treedata2 = !treedata2"
                      >
                        <div class="user-head d-flex align-items-center">
                          <div
                            class="icon-title mr-3 d-flex align-items-center"
                          >
                            <svg
                              style="width: 1.4rem"
                              height="auto"
                              viewBox="0 0 25 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6.5 15L12.5 9L18.5 15"
                                stroke="#fff"
                                stroke-width="1.75"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M6.5 15L12.5 9L18.5 15"
                                stroke="white"
                                stroke-opacity="0.1"
                                stroke-width="1.75"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                          <span class="user-title">Bayu</span>
                        </div>
                        <div class="user-icon d-flex align-items-center">
                          <svg
                            style="width: 1.4rem; height: 1.4rem"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="12.5"
                              cy="7"
                              r="4"
                              stroke="#fff"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <circle
                              cx="12.5"
                              cy="7"
                              r="4"
                              stroke="white"
                              stroke-opacity="0.1"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6.5 21V19C6.5 16.7909 8.29086 15 10.5 15H14.5C16.7091 15 18.5 16.7909 18.5 19V21"
                              stroke="#fff"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6.5 21V19C6.5 16.7909 8.29086 15 10.5 15H14.5C16.7091 15 18.5 16.7909 18.5 19V21"
                              stroke="white"
                              stroke-opacity="0.1"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </div>

                      <b-collapse visible id="treeData-2" v-model="treedata2">
                        <!-- USER CHILDREN -->
                        <div
                          class="user-shared-parent p-3 ml-lg-5 mt-2 d-flex justify-content-between"
                          :class="treedata3 ? null : 'collapsed'"
                          :aria-expanded="treedata3 ? 'true' : 'false'"
                          aria-controls="treeData-3"
                          @click="treedata3 = !treedata3"
                        >
                          <div class="user-head d-flex align-items-center">
                            <div
                              class="icon-title mr-3 d-flex align-items-center"
                            >
                              <svg
                                style="width: 1.4rem"
                                height="auto"
                                viewBox="0 0 25 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.5 15L12.5 9L18.5 15"
                                  stroke="#fff"
                                  stroke-width="1.75"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M6.5 15L12.5 9L18.5 15"
                                  stroke="white"
                                  stroke-opacity="0.1"
                                  stroke-width="1.75"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                            <span class="user-title">Shared</span>
                          </div>
                          <div class="user-icon d-flex align-items-center">
                            <svg
                              style="width: 1.4rem; height: 1.4rem"
                              viewBox="0 0 25 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="9.5"
                                cy="7"
                                r="4"
                                stroke="#fff"
                                stroke-width="1.75"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <circle
                                cx="9.5"
                                cy="7"
                                r="4"
                                stroke="white"
                                stroke-opacity="0.1"
                                stroke-width="1.75"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M3.5 21V19C3.5 16.7909 5.29086 15 7.5 15H11.5C13.7091 15 15.5 16.7909 15.5 19V21"
                                stroke="#fff"
                                stroke-width="1.75"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M3.5 21V19C3.5 16.7909 5.29086 15 7.5 15H11.5C13.7091 15 15.5 16.7909 15.5 19V21"
                                stroke="white"
                                stroke-opacity="0.1"
                                stroke-width="1.75"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M16.5 3.12988C18.2699 3.58305 19.5078 5.17787 19.5078 7.00488C19.5078 8.83189 18.2699 10.4267 16.5 10.8799"
                                stroke="#fff"
                                stroke-width="1.75"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M16.5 3.12988C18.2699 3.58305 19.5078 5.17787 19.5078 7.00488C19.5078 8.83189 18.2699 10.4267 16.5 10.8799"
                                stroke="white"
                                stroke-opacity="0.1"
                                stroke-width="1.75"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M21.5 20.9999V18.9999C21.4896 17.1845 20.2578 15.6037 18.5 15.1499"
                                stroke="#fff"
                                stroke-width="1.75"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M21.5 20.9999V18.9999C21.4896 17.1845 20.2578 15.6037 18.5 15.1499"
                                stroke="white"
                                stroke-opacity="0.1"
                                stroke-width="1.75"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </div>

                        <b-collapse visible id="treeData-3" v-model="treedata3">
                          <div class="user-nested tree-data-3 mt-3 ml-lg-5">
                            <ul>
                              <li>B 1234 TTG</li>
                              <li>B 1234 TTG</li>
                              <li>B 1234 TTG</li>
                            </ul>
                          </div>
                        </b-collapse>

                        <div class="user-nested tree-data-2 mt-3 ml-5">
                          <ul>
                            <li>B 1234 TTG</li>
                            <li>B 1234 TTG</li>
                            <li>B 1234 TTG</li>
                          </ul>
                        </div>
                      </b-collapse>

                      <!-- NESTED -->
                      <div class="user-nested tree-data-1 mt-3">
                        <ul>
                          <li>B 1234 TTG</li>
                          <li>B 1234 TTG</li>
                          <li>B 1234 TTG</li>
                        </ul>
                      </div>
                    </b-collapse>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </l-control>
    </l-map>

    <!-- <vs-button
      @click="active = !active"
      class="sidebar-btn"
      color="primary"
      type="filled"
      >Open Sidebar</vs-button
    > -->

    <!-- <button
      class="sidebar-btn p-2 d-flex align-items-center justify-content-center"
      @click="active = !active"
    >
      <img src="@/assets/images/tabler-icon/indent-decrease.svg" />
    </button> -->
  </div>
</template>

<script>
import {
  LMap,
  LTileLayer,
  LCircle,
  LMarker,
  LControl,
  LPopup
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BCard,
  BCardTitle,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BFormDatepicker,
  BListGroup,
  BListGroupItem,
  BFormRadio,
  BBadge,
  BFormCheckbox,
  VBPopover,
  BPopover,
  BCollapse,
  VBToggle
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import LControlFullscreen from 'vue2-leaflet-fullscreen'

export default {
  components: {
    LMap,
    LTileLayer,
    LCircle,
    LMarker,
    LControl,
    LControlFullscreen,
    LPopup,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BCardTitle,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    vSelect,
    BFormDatepicker,
    flatPickr,
    BListGroup,
    BListGroupItem,
    BFormRadio,
    BBadge,
    BFormCheckbox,
    BPopover,
    BCollapse
  },

  directives: {
    Ripple,
    'b-popover': VBPopover,
    'b-toggle': VBToggle
  },

  data() {
    return {
      active: false,
      url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
      zoom: 17,
      center: [-6.1779895, 106.8128504],
      circle: {
        center: [-6.1779895, 106.8128504],
        radius: 20,
        color: '#EA5455'
      },
      switch1: true,

      showPopup: false,
      treedata1: true,
      treedata2: true,
      treedata3: true,

      showSharePopup: false,

      units: [
        {
          title: 'B 1234 TTG'
        },
        {
          title: 'Unit 2'
        },
        {
          title: 'Unit 3'
        }
      ],

      selected: { title: 'B 1234 TTG' },

      listData: [
        { text: 'Cras justo odio' },
        { text: 'Dapibus ac facilisis in' },
        { text: 'Vestibulum at eros' }
      ],

      items2: [
        {
          pukul: '07:30:15',
          tgl: 'Rabu, 02 November 2022',
          status: 'Mulai'
        },
        {
          pukul: '07:30:30',
          tgl: 'Rabu, 02 November 2022',
          status: 'Moving'
        },
        {
          pukul: '07:30:45',
          tgl: 'Rabu, 02 November 2022',
          status: 'Moving'
        },
        {
          pukul: '07:31:00',
          tgl: 'Rabu, 02 November 2022',
          status: 'Moving'
        },
        {
          pukul: '07:31:00',
          tgl: 'Rabu, 02 November 2022',
          status: 'Moving'
        },
        {
          pukul: '07:31:15',
          tgl: 'Rabu, 02 November 2022',
          status: 'Stop'
        },
        {
          pukul: '07:31:30',
          tgl: 'Rabu, 02 November 2022',
          status: 'Moving'
        },
        {
          pukul: '07:31:45',
          tgl: 'Rabu, 02 November 2022',
          status: 'Alarm'
        }
      ],

      // define the default value
      value: null,
      // define options
      options: [
        {
          id: 'a',
          label: 'a',
          children: [
            {
              id: 'aa',
              label: 'aa'
            },
            {
              id: 'ab',
              label: 'ab'
            }
          ]
        },
        {
          id: 'b',
          label: 'b'
        },
        {
          id: 'c',
          label: 'c'
        }
      ],

      data: [
        {
          name: 'Lihat Semua',
          id: 0,
          children: [],
          name: 'Demo 01',
          id: 0,
          children: [
            {
              name: 'Bayu',
              id: 3,
              children: [
                {
                  name: 'Shared',
                  id: 4,
                  children: []
                },
                {
                  name: 'B 1234 TTG'
                },
                {
                  name: 'B 1234 TTG'
                },
                {
                  name: 'B 1234 TTG'
                }
              ]
            },
            {
              name: 'Bayu',
              id: 3,
              children: [
                {
                  name: 'Shared',
                  id: 4,
                  children: []
                },
                {
                  name: 'B 1234 TTG'
                },
                {
                  name: 'B 1234 TTG'
                },
                {
                  name: 'B 1234 TTG'
                }
              ]
            },
            {
              name: 'B 1234 TTG'
            },
            {
              name: 'B 1234 TTG'
            },
            {
              name: 'B 1234 TTG'
            },
            {
              name: 'B 1234 TTG'
            }
          ]
        }
      ]
      // treeData: [
      //   {
      //     id: 1,
      //     name: 'Demo',
      //     children: [
      //       { id: 3, name: 'Neptune' },
      //       { id: 4, name: 'Stratus' }
      //     ],
      //   }
      // ]
    }
  },

  mounted() {
    $('.sidebar-btn').click()
  },

  methods: {
    showInfo() {
      this.showPopup = !this.showPopup
    },

    showVehicleList() {
      document.getElementById('sidebar').classList.toggle('active')
      document.getElementById('toggle-btn').classList.toggle('closed')
    },

    allowDrag(model, component) {
      if (model.name === 'Node 0-1') {
        // can't be dragged
        return false
      }
      // can be dragged
      return true
    },
    allowDrop(model, component) {
      if (model.name === 'Node 2-2') {
        // can't be placed
        return false
      }
      // can be placed
      return true
    },
    curNodeClicked(model, component) {
      // console.log('curNodeClicked', model, component);
    },
    dragHandler(model, component, e) {
      // console.log('dragHandler: ', model, component, e);
    },
    dragEnterHandler(model, component, e) {
      // console.log('dragEnterHandler: ', model, component, e);
    },
    dragLeaveHandler(model, component, e) {
      // console.log('dragLeaveHandler: ', model, component, e);
    },
    dragOverHandler(model, component, e) {
      // console.log('dragOverHandler: ', model, component, e);
    },
    dragEndHandler(model, component, e) {
      // console.log('dragEndHandler: ', model, component, e);
    },
    dropHandler(model, component, e) {
      // console.log('dropHandler: ', model, component, e);
    }
  }
}
</script>

<style lang="scss">
.vue2leaflet-map {
  &.leaflet-container {
    height: 550px;
  }
}

.parent {
  // position: relative;
  // height: 550px;
  font-family: 'Poppins', sans-serif;
}

.map a.monitor {
  text-decoration: none;
}

.map .monitor-btn {
  background: linear-gradient(45deg, #1da1f2 0%, #1da1f2 0.01%, #62c1fc 100%);
  width: 207px;
  height: 54px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
}

.map .monitor-btn span {
  display: flex;
  align-items: center;
}

.map .vehicle-info {
  background-color: #e8e8e8;
  padding: 2em;
}

.map .filter-btn {
  background: linear-gradient(45deg, #1da1f2 0%, #1da1f2 0.01%, #62c1fc 100%);
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 8px;
  color: #fff;
}

.map .filter-list-item p {
  display: flex;
  align-items: center;
  justify-content: center;
}

.map .fs-search-input {
  background-color: #fff;
  display: flex;
  align-items: center;
  box-shadow: 0px 4px 16px rgba(165, 163, 174, 0.45);
  border-radius: 12px;
  padding: 1.5em 10em 1.5em 1.5em;
}

.map .fs-search-input input {
  border: none;
  background-color: transparent;
}

.sidebar-btn {
  position: absolute;
  top: 50%;
  right: 20%;
  z-index: 9999;
  border-radius: 50%;
  border: none;
  background: linear-gradient(45deg, #1da1f2 0%, #1da1f2 0.01%, #62c1fc 100%);
}

// .sidebar-scroll {
//   overflow: scroll !important;
//   height: 550px;
// }

.inner-sidebar h4 {
  font-weight: 600;
  font-size: 18px;
}

.inner-sidebar .search-input {
  background-color: #f8f7fa;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #1da1f2;
}

.inner-sidebar input {
  border: none;
  background-color: transparent;
}

.user-tree-data {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.user-tree-data .user-parent {
  background-color: #1da1f2;
  border-radius: 6px;
  color: #fff;
}

.user-parent .icon-title,
.user-parent .user-icon {
  background-color: #0082d0;
  border-radius: 4px;
}

.user-nested.tree-data-1 {
  background-color: rgba(0, 207, 232, 0.08);
  border-radius: 6px;
}

.user-nested.tree-data-1 li {
  padding: 0.8rem;
}

.user-tree-data .sub-user-parent {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)),
    #28c76f;
  border-radius: 6px;
  color: #fff;
}

.sub-user-parent .icon-title,
.sub-user-parent .user-icon {
  background-color: #28c76f;
  border-radius: 4px;
}

.user-nested.tree-data-2 {
  background-color: rgba(115, 103, 240, 0.08);
  border-radius: 6px;
}

.user-nested.tree-data-2 li {
  padding: 0.8rem;
}

.user-tree-data .user-shared-parent {
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 0.1)
    ),
    #4b465c;
  border-radius: 6px;
  color: #fff;
}

.user-shared-parent .icon-title,
.user-shared-parent .user-icon {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)),
    #a8aaae;
  border-radius: 4px;
}

.user-nested.tree-data-3 {
  background-color: rgba(168, 170, 174, 0.08);
  border-radius: 6px;
}

.user-nested.tree-data-3 li {
  padding: 0.8rem;
}

#sidebar {
  position: absolute;
  width: 18vw;
  height: 550px;
  background-color: #fff;
  right: -340px;
  top: -10px;
  transition: 0.7s;
}

#sidebar #toggle-btn {
  position: absolute;
  top: 50%;
  right: 340px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(45deg, #1da1f2 0%, #1da1f2 0.01%, #62c1fc 100%);
  transform: rotate(180deg);
}

#sidebar.active {
  right: -10px;
}

#sidebar.active #toggle-btn {
  right: 100%;
}

#toggle-btn.closed img {
  transform: rotate(180deg);
}
</style>
